import OSS from 'ali-oss';

const getAdminAuthHeaders = () => {
    const headers = {};
    const authToken = localStorage.getItem("authcheck");
    const token = localStorage.getItem("token");

    if (authToken) {
        headers["auth-token"] = authToken;
    }
    if (token) {
        headers["authorization"] = `Bearer ${token}`;
    }

    return headers;
};

const fetchOssCredentials = async () => {
    const response = await fetch(`${process.env.REACT_APP_API_BASEURL}/get_cred`, {
        headers: getAdminAuthHeaders(),
    });
    const data = await response.json();
    if (!response.ok || !data.accessKeyId || !data.accessKeySecret || !data.bucket) {
        throw new Error(data.response || data.message || 'Unable to get OSS credentials');
    }
    return data;
};

export const getOssClient = async () => {
    try {
        const {
            accessKeyId,
            accessKeySecret,
            bucket,
            stsToken
        } = await fetchOssCredentials();
        return new OSS({
            region: 'oss-me-central-1',
            accessKeyId: accessKeyId,
            accessKeySecret: accessKeySecret,
            stsToken: stsToken,
            bucket: bucket,
            // secure: true,
            refreshSTSToken: async () => {
                const data = await fetchOssCredentials();
                return {
                    accessKeyId: data.accessKeyId,
                    accessKeySecret: data.accessKeySecret,
                    stsToken: data.stsToken,
                    secure: false,
                };
            },
            refreshSTSTokenInterval: 300000
        });
    } catch (error) {
        console.error('Error getting OSS client:', error);
        throw error;
    }
};
